var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterButn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.049,
    height: 13.653,
    viewBox: "0 0 17.049 13.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "filter_2_",
    "data-name": "filter (2)",
    d: "M.533,53.735H9.207a2.218,2.218,0,0,0,4.307,0h3a.533.533,0,0,0,0-1.066h-3a2.218,2.218,0,0,0-4.307,0H.533a.533.533,0,0,0,0,1.066ZM11.361,52.05A1.153,1.153,0,1,1,10.208,53.2,1.154,1.154,0,0,1,11.361,52.05ZM.533,58.343h3a2.218,2.218,0,0,0,4.307,0h8.675a.533.533,0,0,0,0-1.066H7.841a2.218,2.218,0,0,0-4.307,0h-3a.533.533,0,0,0,0,1.066Zm5.155-1.686a1.153,1.153,0,1,1-1.153,1.153A1.154,1.154,0,0,1,5.688,56.658Zm10.828,5.228h-3a2.218,2.218,0,0,0-4.307,0H.533a.533.533,0,0,0,0,1.066H9.207a2.218,2.218,0,0,0,4.307,0h3a.533.533,0,0,0,0-1.066Zm-5.155,1.686a1.153,1.153,0,1,1,1.153-1.153A1.154,1.154,0,0,1,11.361,63.572Z",
    transform: "translate(0 -50.984)",
    fill: "#347fb7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterButn);
export default __webpack_public_path__ + "static/media/filter-butn.7f78076b78a7e44e7641ec16c799ed9c.svg";
export { ForwardRef as ReactComponent };